<template>
  <div class="solution-item">
    <slot name="icon"></slot>
    <div class="content">
      <div v-if="title" class="title">{{ title }}</div>
      <div v-if="desc" class="desc">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.solution-item {
  display: flex;
  align-items: flex-start;
}

.content {
  flex: 1;
  text-align: left;
  margin-left: 12px;
}

.title {
  color: #1f2329;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
}

.desc {
  color: #50627f;
  font-size: 16px;
  font-weight: 400;
  line-height: 170%;
}

@media screen and (max-width: 1000px) {
  .solution-item .title {
    font-size: 16px !important;
    line-height: 20px !important;
    margin-bottom: 8px !important;
  }

  .solution-item .desc {
    font-size: 14px !important;
  }

  svg {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>